import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { OpenSizingInventoryHeader } from "@faire/retailer-visitor-shared/features/PointOfSale/components/PDPInventory/OpenSizingInventoryHeader";
import { OpenSizingVariantPOSInventory } from "@faire/retailer-visitor-shared/features/PointOfSale/components/PDPInventory/OpenSizingVariantPOSInventory";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { OpenSizingVariationHelper } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/OpenSizingVariationHelper";
import { OpenSizingVariationInput } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/OpenSizingVariationInput";
import { OpenSizingVariationLabel } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/OpenSizingVariationLabel";
import { SizeChartLink } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/SizeChartLink";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Column, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IGetProductOptionInventoryRequest } from "@faire/web-api--source/indigofair/retailers/pos/IGetProductOptionInventoryRequest";
import { useQuery_escape_hatch as useInventoryQuery } from "@faire/web-api--source/retailers-pos-api/product-option-inventory/post-hooks";
import { observer } from "mobx-react";
import React, { useMemo } from "react";
import styled from "styled-components";
var OpenSizingVariantTableBase = function(param) {
    var brand = param.brand, product = param.product, perStyleOptionVariation = param.perStyleOptionVariation, minimumOrderQuantity = param.minimumOrderQuantity, perStyleTotalQuantity = param.perStyleTotalQuantity, updateSelectedQuantityByToken = param.updateSelectedQuantityByToken;
    var hasLinkedPOS = usePOSSummary().hasLinkedPOS;
    var data = useInventoryQuery(IGetProductOptionInventoryRequest.build({
        product_option_tokens: perStyleOptionVariation.map(function(variation) {
            return variation.productOptionToken;
        })
    }), {
        enabled: hasLinkedPOS
    }).data;
    var hasOptionsWithInventory = useMemo(function() {
        return perStyleOptionVariation.some(function(variation) {
            var _data_inventory_data_by_product_option_variation_productOptionToken;
            return (data === null || data === void 0 ? void 0 : (_data_inventory_data_by_product_option_variation_productOptionToken = data.inventory_data_by_product_option[variation.productOptionToken]) === null || _data_inventory_data_by_product_option_variation_productOptionToken === void 0 ? void 0 : _data_inventory_data_by_product_option_variation_productOptionToken.total_inventory) !== undefined;
        });
    }, [
        data,
        perStyleOptionVariation
    ]);
    var getPOSInventory = function(token) {
        var _data_inventory_data_by_product_option_token;
        return data === null || data === void 0 ? void 0 : (_data_inventory_data_by_product_option_token = data.inventory_data_by_product_option[token]) === null || _data_inventory_data_by_product_option_token === void 0 ? void 0 : _data_inventory_data_by_product_option_token.total_inventory;
    };
    var handleChange = function(token) {
        return function(value) {
            return updateSelectedQuantityByToken(token, Math.max(value, 0));
        };
    };
    return /*#__PURE__*/ _jsxs(Column, {
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                style: {
                    alignItems: "end"
                },
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        gap: "1x",
                        style: {
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "I8fyGl",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Sizes"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(SizeChartLink, {
                                brand: brand,
                                product: product
                            })
                        ]
                    }),
                    hasLinkedPOS ? /*#__PURE__*/ _jsx(OpenSizingInventoryHeader, {
                        isEmpty: !hasOptionsWithInventory
                    }) : /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        style: {
                            justifySelf: "center"
                        },
                        "data-test-id": "open-sizing-table-moq",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "MDOJy6",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Min Qty "
                                },
                                {
                                    type: 1,
                                    value: "minimumOrderQuantity"
                                }
                            ],
                            values: DEPRECATED_backwardsCompatibleValues({
                                minimumOrderQuantity: minimumOrderQuantity
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            perStyleOptionVariation.map(function(variation) {
                return /*#__PURE__*/ _jsx(TableRow, {
                    variation: variation,
                    onChange: handleChange(variation.productOptionToken),
                    posInventoryCount: getPOSInventory(variation.productOptionToken)
                }, variation.productOptionToken);
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "+AjN08",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Total"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        style: {
                            justifySelf: "center"
                        },
                        "data-test-id": "open-sizing-total-quantity",
                        children: perStyleTotalQuantity
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            })
        ]
    });
};
export var OpenSizingVariantTable = observer(OpenSizingVariantTableBase);
var Grid = styled.div.withConfig({
    componentId: "sc-1f15d392-0"
})([
    "display:grid;grid-template-columns:1fr 80px 120px;column-gap:",
    ";align-items:center;"
], getSpacing("1x"));
var TableRow = function(param) {
    var variation = param.variation, posInventoryCount = param.posInventoryCount, onChange = param.onChange;
    var hasLinkedPOS = usePOSSummary().hasLinkedPOS;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: "1x",
        style: {
            padding: getSpacing("1x", 0),
            borderBottom: "1px solid ".concat(Core.border.muted)
        },
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                children: [
                    /*#__PURE__*/ _jsx(OpenSizingVariationLabel, {
                        variation: variation
                    }),
                    hasLinkedPOS && posInventoryCount !== undefined ? /*#__PURE__*/ _jsx(OpenSizingVariantPOSInventory, {
                        count: posInventoryCount
                    }) : /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(OpenSizingVariationInput, {
                        variation: variation,
                        onChange: onChange
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(OpenSizingVariationHelper, {
                variation: variation
            })
        ]
    });
};
